<template>
  <div class="search">
    <header>
      <input type="text" placeholder="搜索" v-model="name">
      <span @click="search" v-show="is_show">确定</span>
      <span @click="$router.go(-1)" v-show="!is_show">取消</span>
      <img src="../assets/img/006.png" alt="">
    </header>
    <main>
      <div class="modules_box" v-for="item in modulesList" :key="item.item.id">
        <div class="title">
          <img src="../assets/img/007.png" alt="">
          <p>{{item.item.name}}</p>
        </div>
        <ul>
          <li v-for="val in item.content.data" :key="val.id">
            <img src="../assets/img/bg_05.png" alt="">
            <p class="p1">{{val.name}}</p>
            <p class="p2">{{val.describe}}</p>
          </li>
        </ul>
        <p class="mover" @click="moverList(item.item.id,item.content.current_page,item.content.last_page,item)">点击加载更多</p>
      </div>
      <!-- <div class="modules_box">
        <div class="title">
          <img src="../assets/img/007.png" alt="">
          <p>主题活动</p>
        </div>
        <ul>
          <li>
            <img src="../assets/img/bg_05.png" alt="">
            <p class="p1">标题标题标题</p>
            <p class="p2">内容描述，内容描述，内容描述，内容</p>
          </li>
          <li>
            <img src="../assets/img/bg_05.png" alt="">
            <p class="p1">标题标题标题</p>
            <p class="p2">内容描述，内容描述，内容描述，内容</p>
          </li>
          <li>
            <img src="../assets/img/bg_05.png" alt="">
            <p class="p1">标题标题标题</p>
            <p class="p2">内容描述，内容描述，内容描述，内容</p>
          </li>
        </ul>
        <p class="mover">点击加载更多</p>
      </div> -->
    </main>
  </div>
</template>


<script>
export default {
  data() {
    return {
      name: '',
      is_show: true,
      modulesList: []
    }
  },
  methods: {
    async search() {
      const res = await this.axios.get(`/contents/search_index?key=${this.name}&page=1`)
      if (res.code === 1) {
        this.is_show = false
        this.modulesList = res.data
      }
      console.log(res)
    },
    async moverList(id, current_page, last_page, item) {
      if (current_page < last_page) {
        const res = await this.axios.get(`/contents/search_list?key=${this.name}&page=${current_page + 1}&items_id=${id}`)
        if (res.code === 1) {
          console.log(res.data.data)
          res.data.data.forEach(element => {
            item.content.data.push(element)
          });
          item.content.current_page = res.data.current_page
          console.log(item)
        }
      } else {
        this.$toast('没有更多了')
      }
    }
  }
}
</script>


<style lang="less" scoped>
.search {
  min-height: 100vh;
  header {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.16rem;
    box-sizing: border-box;
    position: relative;
    input {
      width: 6.25rem;
      height: 0.68rem;
      border-radius: 0.34rem;
      background: #e8e8e8;
      border: none;
      font-size: 15px;
      padding-left: 1rem;
      box-sizing: border-box;
    }
    span {
      font-size: 0.32rem;
    }
    img {
      width: 0.43rem;
      height: 0.43rem;
      position: absolute;
      left: 0.41rem;
      top: 50%;
      transform: translate(0, -50%);
    }
  }
  main {
    padding-top: 0.41rem;
    padding-bottom: 0.5rem;
    .modules_box {
      box-sizing: border-box;
      padding-left: 0.43rem;
      margin-bottom: 0.59rem;
      .title {
        display: flex;
        align-items: center;
        img {
          width: 0.11rem;
          height: 0.47rem;
          margin-right: 0.28rem;
        }
        p {
          font-size: 0.34rem;
          color: #292b2d;
          font-weight: bold;
          margin: 0;
        }
      }
      ul {
        padding-top: 0.26rem;
        li {
          margin-bottom: 0.3rem;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          padding-left: 0.28rem;
          padding-right: 0.5rem;
          p {
            margin: 0;
          }
          img {
            width: 0.1rem;
            height: 0.1rem;
          }
          .p1 {
            font-size: 0.3rem;
            color: #838282;
            font-weight: 500;
            padding-left: 0.1rem;
          }
          .p2 {
            font-size: 0.2rem;
            color: #999999;
            padding-left: 0.1rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
      .mover {
        font-size: 0.2rem;
        color: #ff8179;
        text-align: center;
      }
    }
  }
}
</style>